import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 w-full h-full bg-white" }, null, -1)
const _hoisted_2 = { class: "fixed inset-0 overflow-y-auto" }
const _hoisted_3 = { class: "flex items-center justify-center min-h-full p-4 text-center" }
const _hoisted_4 = {
  role: "status",
  tabindex: "0",
  class: "fixed h-20 -translate-x-1/2 -translate-y-1/2 w-fit top-2/4 left-1/2 focus:outline-none"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/CPN-Logo.png",
  alt: "logo",
  class: "w-[200px] h-[87px] object-contain lock mx-auto"
}, null, -1)
const _hoisted_6 = { class: "w-full bg-gray-200 rounded-full h-2.5 mb-4 dark:bg-gray-700" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, " Please wait, downloading resources... ")
], -1)

import { ref, onMounted } from "vue";
import http from "@/axios";
import {
    TransitionRoot,
    TransitionChild,
    Dialog,
} from '@headlessui/vue';

import { Network } from '@capacitor/network';
import Storage from "@/helpers/storage";
import DownloadResourcesService from "@/classes/Synching/Offline/DownloadResources/DownloadResourcesService";
import InterventionService from "@/classes/Interventions/InterventionService";
import { useRecordStatusChecker } from "@/store/recordStatusChecker";


export default /*#__PURE__*/_defineComponent({
  __name: 'SyncSplashModal',
  setup(__props) {

const percentage = ref<number>(0)
const show = ref<boolean>(false)

const storage = new Storage();

const currentUser = JSON.parse(storage.get("user"));

const offlineDropdowns: object[] = DownloadResourcesService.setTable();

const config = {
    onUploadProgress: function (progressEvent: any) {
        percentage.value = Math.round((progressEvent.loaded * 100) / progressEvent.total);
    }
};
const recordStatusChecker = useRecordStatusChecker();

const chunkArray = (data:string[], size: number): any => {

    const chunkedArray:any[] = [];
    
    data.forEach((item, index) => {
        if (index % size === 0) {
            chunkedArray.push(data.slice(index, index + size));
        }
    });

    return chunkedArray;
}

const sync = async (): Promise<any> => {
    // stop processing when downloading resources was already finised
    if (eval(storage.get('isDownloadedResources'))) {
        console.log('Resources already downloaded');
        return;
    }

    show.value = true;
    recordStatusChecker.isDownloadingResources = true;
    const unloadedOptions:string[] = [];
    offlineDropdowns.forEach(
        (item:any) => {
            unloadedOptions.push(item.params)
        }
    );
    const chunk = chunkArray(unloadedOptions, 10);
    for (const index in chunk) {
        const items = chunk[index];
        const { data } = await http.post(`sync/options/get`,{ options: items }).catch(error => error)
        await DownloadResourcesService.storeOptions(data);
    } 
    // download intervention form structures
    await InterventionService.getFormStructure();
    storage.set('isDownloadedResources', true);
    show.value = false;
    recordStatusChecker.isDownloadingResources = false;
}

const logCurrentNetworkStatus = async (): Promise<any> => {
    const status = await Network.getStatus();

    if (status.connected) {
        sync()
    }
};

onMounted(() => {
    sync();
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    appear: "",
    show: show.value,
    as: "template"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        as: "div",
        onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
        class: "relative z-50"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(TransitionChild), {
            as: "template",
            enter: "duration-300 ease-out",
            "enter-from": "opacity-0",
            "enter-to": "opacity-100",
            leave: "duration-200 ease-in",
            "leave-from": "opacity-100",
            "leave-to": "opacity-0"
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "duration-300 ease-out",
                "enter-from": "opacity-0 scale-95",
                "enter-to": "opacity-100 scale-100",
                leave: "duration-200 ease-in",
                "leave-from": "opacity-100 scale-100",
                "leave-to": "opacity-0 scale-95"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _hoisted_5,
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", {
                        class: "bg-blue-600 h-2.5 rounded-full dark:bg-blue-500",
                        style: _normalizeStyle({ width: `${percentage.value}%`})
                      }, null, 4)
                    ]),
                    _hoisted_7
                  ])
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})